/**
 * Created by Rodrigo Quesada on 23/03/17.
 */
import {Directive, HostBinding, Input} from '@angular/core';
import {AuthService} from './auth.service';
import {ReplaySubject} from 'rxjs';
import {combineLatest} from 'rxjs/observable/combineLatest';

@Directive({
    selector: '[hasRole]'
})
export class HasRoleDirective {

    @HostBinding('class.hidden-xs-up') hidden: boolean;

    // region Input
    private _roles$ = new ReplaySubject<string[]>(1);

    @Input() set hasRole(value: string[]) { this._roles$.next(value); }

    // endregion

    constructor(private _authService: AuthService) {

        combineLatest(this._roles$, this._authService.user$, (roles, user) => user && user.hasAnyRole(roles))
            .subscribe(hasRoles => this.hidden = !hasRoles);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/authorization/has-role.directive.ts